import Link from 'next/link';

import Button from '@/v2/components/Button/Button';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import authConstants from '@/v2/domains/Auth/constants/constants';

import LoginMenuButton from './LoginMenuButton';
import SignUpMenuButton from './SignUpMenuButton';

export default function MenuButtons({ onClickButton }) {
  const { userType } = useCurrentUser();

  if (userType) {
    return (
      <DashboardButton userType={userType} onClickButton={onClickButton} />
    );
  }

  return (
    <>
      <LoginMenuButton onClickButton={onClickButton} />
      <SignUpMenuButton onClickButton={onClickButton} />
    </>
  );
}

function DashboardButton({ userType, onClickButton }) {
  const prefix = {
    [authConstants.userType.teacher]: '',
    [authConstants.userType.student]: '/student',
    [authConstants.userType.admin]: '/admin',
  }[userType];

  return (
    <Link href={`${prefix}/dashboard`}>
      <Button size="large" onClick={onClickButton} block>
        Go to Dashboard
      </Button>
    </Link>
  );
}
